export default "__VITE_ASSET__BbMoZW5o__"